'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const accountEventRoutes = [
  {
    path: 'events',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'account.event',
        redirect: { name: 'profile.event.organized.list' },
        // props: true,
        // component: () => import('../views/ManageEventListView.vue'),
      },
      {
        path: 'organized',
        name: 'account.event.organized.list',
        props: true,
        component: () => import('../views/OrganizedListView.vue'),
      },
    ],
  },
];
